import { useState } from 'react';
import { noop } from '../../../../../common/utils/helpers';
import { stringEmpty } from '../../../../../common/utils/text';
import { ProjectApi } from '../../../api/project-api';

export const validateProject = (project, differentInspirationsOptions, itemsOptions, consultancy, roomStyling, designFix) => {
  const errors = [];
  const { questionnaire, finishingTouchesData, images_inspiration, selectedAdults, selectedChilds, id, items_to_buy } = project.state;

  const submitFamilyMembers = () => {
    const output = selectedAdults.map((value, index) => {
      return {
        male: value,
      };
    });
    const output2 = selectedChilds.map((value, index) => {
      return {
        male: value,
      };
    });
    const output3 = {"adults":{...output},"children":{...output2}}
    const array1Status = output.length === 0;
    const array2Status = output2.length === 0;
    if (array1Status == false || array2Status == false) {
      ProjectApi.updateProject(id, { questionnaire_attributes: { peoples: output3 }}, response => {
        project.setState({ updated_at: response.updated_at });
      }, noop);
      return true;
    } else {
      return false;
    };
  };

  // Who lives in your property?
  const validateFamilyMembers = () => {
    const family = submitFamilyMembers();
    if(!family){
      errors.push(['family_members', 'required']);
    }
  };

  const validateRoomStylingType = () => {
    if (!questionnaire['room_styling_type']) {
      errors.push(['room_styling_type', 'required']);
    }
  };

  const validateByKey = key => {
    if (!questionnaire[key]) {
      errors.push([key, 'required']);
    }
  };

  const validateNote = () => {
    validateByKey('note');
  };

  // room_styling
  if (designFix) {
    validateRoomStylingType();
    validateFamilyMembers();
    validateNote();
    return {
      valid: !errors.length,
      errors,
    };

  }


  if (roomStyling) {
    validateRoomStylingType()
  };

  // // What are your biggest issues with this room? Select all that apply.
  // if (!consultancy) {
  //   ['issues'].forEach(key => {
  //     if (!questionnaire[key].length) {
  //       errors[key] = 'required';
  //     }
  //   });
  // }

  // What items do you already know you want us to source for your room design?
  // if (!consultancy && roomStyling && !questionnaire.items_to_source) {
  //   const items = items_to_buy.reduce((acct, i) => [...acct, ...i.values], []);
  //   const checked = items.find(i => i.checked);
  //   if (!checked) {
  //     errors.items_to_buy = 'required';
  //   }
  // }

  if (!consultancy && differentInspirationsOptions) {
    const questionnaireKeys = Object.keys(questionnaire.inspirations);
    Object.keys(differentInspirationsOptions).forEach(key => {
      const option = questionnaireKeys.find(k => k.includes(key));
      if (!option) {
        errors.push([key, 'required']);
      }
    });
  }

  if (!consultancy) {
    ['color'].forEach(key => {
      if (!Object.keys(questionnaire[key]).length) {
        errors.push([key, 'required']);
      }
    });
  }

  if (!consultancy && itemsOptions) {
    const questionnaireKeys = Object.keys(questionnaire.items);
    Object.keys(itemsOptions).forEach(key => {
      const option = questionnaireKeys.find(k => k.includes(key));
      if (!option) {
        errors.push([key, 'required']);
      }
    });
  }

  if (!consultancy) {
    ['artworks', 'pattern', 'fabric', 'material'].forEach(key => {
      if (!Object.keys(questionnaire[key]).length) {
        errors.push([key, 'required']);
      }
    });
  }

  if(!consultancy && roomStyling) {
    // What finishing touches would you like us to source?
    if(!finishingTouchesData.length){
      errors.push(['finishingTouchesRequired', 'required']);
    }
  }

  validateFamilyMembers();
  // //Who lives in your property?
  // const family = submitFamilyMembers();
  // if(!family){
  //   errors.push(['family_members', 'required']);
  // }

  // What's your budget for this room?
  if (!consultancy) {
      if (!Object.keys(questionnaire.budget).length || !questionnaire.budget.optimal || !questionnaire.budget.maximum) {
        errors.push(['budget', 'required']);
      }
  }

  if (!consultancy) {
    validateNote();
  }

  if (!consultancy) {
    ['ownership_stage', 'completion_timeline'].forEach(key => {
      if (!questionnaire[key]) {
        errors.push([key, 'required']);
      }
    });
  }

  // Please upload photos of the room, including all four walls
  ['main', 'floor_plan'].forEach(keySuffix => {
    const imageKey = `images_${keySuffix}`;
    const imagesCount = project.state[imageKey].length;
    const documentsCount = project.state.documents.filter(d => d.kind === keySuffix).length;
    if (!imagesCount && !documentsCount) {
      errors.push([imageKey, 'required']);
    }
  });

  // if (!consultancy) {
  //   ['frame', 'item_descriptions', 'storage'].forEach(key => {
  //     if (!questionnaire[key]) {
  //       errors[key] = 'required';
  //     }
  //   });
  // }

  //   It is extremely helpful to share some inspiration on what you like. Not sure where to start?
  // Visit out our  Pinterest account  for inspiration.
  if (
    stringEmpty(questionnaire.pinterest_link) &&
    stringEmpty(questionnaire.houzz_link) &&
    !questionnaire.additional_links.some(str => !stringEmpty(str)) &&
    (!images_inspiration || images_inspiration.length === 0)
  ) {
    errors.push(['inspirations', 'required']);
  }

  return {
    valid: !errors.length,
    errors,
  };
};



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/CustomerDesign/utils.js